import { Box, Modal, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import { information } from "../../constants/locationData";
import { setNavBarInputFields } from "../../app/store/reducer";

export default function SearchFilterModal({ open, setOpen }) {
  const categories = [
    "Salon",
    "Men’s Parlour",
    "Beauty Parlour",
    "Unisex Parlour",
    "Massage Center",
    "Wellness Center",
    "Tatto Art Artist",
    "Mehandi Artist",
    "Skin Care Studio",
    "Panchakarma",
    "Makeup & Hairstyle Artist",
    "Nail Art",
  ];

  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields
  );

  const dispatch = useDispatch();

  // Prevent click inside modal from closing it
  const handleBoxClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      hideBackdrop
    >
      <Box
        onClick={() => setOpen(false)} // Click outside closes modal
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          outline: "none",
        }}
      >
        <Box
          onClick={handleBoxClick} // Prevent closing when clicking inside modal
          sx={{
            background: "white",
            padding: "15px",
            width: "350px",
            borderRadius: "10px",
            position: "absolute",
            top: "13.5%",
            left: "50%",
            transform: "translate(-50%, 0)",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            Categories
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            {categories?.map((category, idx) => (
              <Typography
                key={idx}
                sx={{
                  boxShadow: "0px 1px 8.4px 0px #00000040",
                  borderRadius: "15px",
                  height: "25px",
                  fontWeight: 500,
                  padding: "2px 16px",
                  marginBottom: "4px",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  background: category === "Salon" ? "#CECEFF" : "#fff",
                  color: category === "Salon" ? "primary.main" : "black",
                  cursor: "pointer",
                }}
              >
                {category}
                {category === "Salon" ? (
                  <ClearIcon sx={{ fontSize: "18px", marginLeft: "8px" }} />
                ) : (
                  ""
                )}
              </Typography>
            ))}
          </Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              marginTop: "20px",
            }}
          >
            Location
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <Typography
              sx={{
                boxShadow: "0px 1px 8.4px 0px #00000040",
                borderRadius: "15px",
                height: "25px",
                fontWeight: 500,
                padding: "2px 16px",
                marginBottom: "4px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#CECEFF",
                color: "primary.main",
                cursor: "pointer",
              }}
            >
              {navBarInputFields?.location}
              <ClearIcon sx={{ fontSize: "18px", marginLeft: "8px" }} />
            </Typography>
            {information?.map((item, idx) => {
              if(item?.location === navBarInputFields?.location) return null;
              return (
              <Typography
                sx={{
                  boxShadow: "0px 1px 8.4px 0px #00000040",
                  borderRadius: "15px",
                  height: "25px",
                  fontWeight: 500,
                  padding: "2px 16px",
                  marginBottom: "4px",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#fff",
                  cursor: "pointer",
                }}
                onClick={() =>
                  dispatch(setNavBarInputFields({ location: item?.location }))
                }
              >
                {item?.location}
              </Typography>)
            })}
          </Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              marginTop: "20px",
            }}
          >
            Gender
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <Typography
              sx={{
                boxShadow: "0px 1px 8.4px 0px #00000040",
                borderRadius: "15px",
                height: "25px",
                fontWeight: 500,
                padding: "2px 16px",
                marginBottom: "4px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Men’s Parlour
            </Typography>
            <Typography
              sx={{
                boxShadow: "0px 1px 8.4px 0px #00000040",
                borderRadius: "15px",
                height: "25px",
                fontWeight: 500,
                padding: "2px 16px",
                marginBottom: "4px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Ladies Parlour
            </Typography>
            <Typography
              sx={{
                boxShadow: "0px 1px 8.4px 0px #00000040",
                borderRadius: "15px",
                height: "25px",
                fontWeight: 500,
                padding: "2px 16px",
                marginBottom: "4px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Unisex Parlour
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              marginTop: "20px",
            }}
          >
            Service At
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <Typography
              sx={{
                boxShadow: "0px 1px 8.4px 0px #00000040",
                borderRadius: "15px",
                height: "25px",
                fontWeight: 500,
                padding: "2px 16px",
                marginBottom: "4px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Parlour
            </Typography>
            <Typography
              sx={{
                boxShadow: "0px 1px 8.4px 0px #00000040",
                borderRadius: "15px",
                height: "25px",
                fontWeight: 500,
                padding: "2px 16px",
                marginBottom: "4px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Home
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
